/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-03-09 16:30:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-10-17 17:18:03
 */

import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { renderRoutes } from "assets/renderRouter";
import Loadable from "react-loadable"; //按需加载路由插件
import { Provider } from "react-redux";
import { store } from "../tools/store";
import Sunnbirdback from './sunnbird/sunnbirdback'

const MyLoadingComponent = (v: { isLoading: any; error: any }) => {
  if (v.isLoading) {
    return <div>Loading...</div>;
  } else if (v.error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};

const lazyRoute = (loader: () => Promise<any>) =>
  Loadable({ loader, loading: MyLoadingComponent });

const routes = [
  { path: "/landing",          component: lazyRoute(() => import("../views/landing")) },        // 落地页
  { path: "/scancoupon",       component: lazyRoute(() => import("../views/scancoupon")) },     // 二维码扫码
  { path: "/scanorderEvaluate",component: lazyRoute(() => import("./scanorderEvaluate")) },
  { path: "/model",            component: lazyRoute(() => import("../views/model")) },          // 选择机型
  { path: "/order",            component: lazyRoute(() => import("../views/order")) },          // 新首页
  { path: "/modelPrice",       component: lazyRoute(() => import("../views/modelPrice")) },     // 手机价格查询
  { path: "/faultType",        component: lazyRoute(() => import("../views/faultType")) },      // 寄售错误类型页面
  { path: "/shops",            component: lazyRoute(() => import("../views/shops")) },          // 店铺列表
  { path: "/deshops",          component: lazyRoute(() => import("./shops/delist")) },          // 泰国店铺列表
  { path: "/shopDetails/:id",  component: lazyRoute(() => import("../views/shopDetails")) },    // 店铺详情
  { path: "/reserSuccess",     component: lazyRoute(() => import("../views/reserSuccess")) },   // 下单成功页
  { path: "/checkDetails",     component: lazyRoute(() => import("./checkdetails")) },          // 查看物流列表页面
  { path: "/deliverydetails",  component: lazyRoute(() => import("./deliverydetails")) },       // 查看物流列表页面
  { path: "/sunnbird",         component: lazyRoute(() => import("./sunnbird")) },              // 接入 sunnbird 下单
  { path: "/ccPurchaseService",component: lazyRoute(() => import("./ccPurchaseService")) },
  { path: "/",                 redirect: "/landing" },
];

const mRoute = () => {
  return (
    <Provider store={store}>
      <Router>{renderRoutes(routes)}<Sunnbirdback /></Router>
    </Provider>
  );
};

export default mRoute;
